import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Devportal } from '@/services/apis';

interface StateType {
  devportals?: any[];
  loading?: boolean;
  error?: boolean;
  errorMessage?: string;
  totalDevportals?: number;
  organizationAdmins?: any[];
  totalOrganizationAdminsCount?: number;
}

const initialState: StateType = {
  devportals: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalDevportals: 0,
  organizationAdmins: [],
  totalOrganizationAdminsCount: 0
};

export const fetchdevportals = createAsyncThunk(
  'devportal/fetchdevportals',
  async ({ domainName, organizationName, page, rowsPerPage, applicationType, apiStatus, apiName }: any) => {
    const response = await Devportal.fetchDeveloper({
      domainName,
      organizationName,
      pageNumber: page,
      pageSize: rowsPerPage,
      applicationType: applicationType,
      apiStatus: apiStatus,
      apiName: apiName
    });
    return response;
  }
);

export const fetchApiDetails = createAsyncThunk('devportal/fetchApiDetails', async (id: any) => {
  const response = await Devportal.fetchApiDetails(id);
  return response;
});

export const fetchdevportalsApp = createAsyncThunk(
  'devportal/fetchdevportalsApp',
  async ({ domainName, organizationName, page, rowsPerPage, applicationtype, apiId }: any) => {
    const response = await Devportal.fetchDeveloperApp({
      domainName,
      organizationName,
      pageNumber: page,
      pageSize: rowsPerPage,
      applicationtype: applicationtype,
      apiId: apiId
    });
    return response;
  }
);

export const mappingAdd = createAsyncThunk('devportal/mapping/add', async (data: any) => {
  try {
    const response = await Devportal.mappingAddDevportal(data);
    return response;
  } catch (err: any) {
    console.log(err?.message);
  }
});

export const mappingRemove = createAsyncThunk('devportal/mapping/remove', async (data: any) => {
  try {
    const response = await Devportal.mappingRemoveDevportal(data);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const developerSlice = createSlice({
  name: 'devportal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchdevportals.pending, (state) => {});
    builder.addCase(fetchdevportals.fulfilled, (state, { payload }) => {
      return { ...state, devportals: payload?.result?.apis, totalDevportals: payload?.totalRecords, loading: false };
    });
    builder.addCase(fetchdevportals.rejected, (state) => {});
  }
});

export const organizationSelector = (state: any) => state.domain;

export default developerSlice.reducer;
